import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { ROUTES } from "@/router/route-consts";


export default /*#__PURE__*/_defineComponent({
  __name: 'CloseSession',
  setup(__props) {

onMounted(() => {
    const router = useRouter();
    if (window === parent) {
        console.log("Change route close-session");
        router.push({ path: ROUTES.HALLS.path }).then();
    } else {
        console.log("Post message close-session");
        parent.postMessage("close-session", "*");
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Close session"))
}
}

})